import React from 'react';
import ReactDOM from 'react-dom';
import { useTutorial } from '../context/TutorialContext';
import './TutorialSkipButton.css';

const TutorialSkipButton = () => {
  const { isActive, skipTutorial } = useTutorial();

  if (!isActive) return null;

  return ReactDOM.createPortal(
    <button
      className="tutorial-skip-button"
      onClick={skipTutorial}
      aria-label="Skip tutorial"
    >
      Skip tutorial
    </button>,
    document.body
  );
};

export default TutorialSkipButton;
